import { Box, Typography } from '@mui/material';
import type { Currency } from '@vy/types';
import { DEFAULT_CURRENCY } from '@vy/types';
import { useMemo } from 'react';
import { Price } from '../../../../../components/design/Price';
import type { BillingForecastBreakdownInvoice } from './billing-forecast-report-aggregator';

type BillingForecastInvoiceDetailPanelProps = {
  invoices: BillingForecastBreakdownInvoice[];
  monthHeaders: string[];
};

const cellSx = { display: 'flex', justifyContent: 'center', fontSize: '13px' };

export const BillingForecastInvoiceDetailPanel: React.FC<BillingForecastInvoiceDetailPanelProps> = ({
  invoices,
  monthHeaders,
}) => {
  const gridTemplateColumns = useMemo(
    () => `40px 1fr ${'1fr '.repeat(monthHeaders.length)}1fr`,
    [monthHeaders.length],
  );

  return (
    <Box sx={{ py: 1, backgroundColor: 'grey.50' }}>
      {invoices.map((breakdownInvoice) => {
        const currency = (breakdownInvoice.currency ?? DEFAULT_CURRENCY) as Currency;
        const invoice = breakdownInvoice.invoice;

        return (
          <Box
            key={invoice.id}
            sx={{
              display: 'grid',
              gridTemplateColumns,
              alignItems: 'center',
              py: 0.75,
              borderBottom: '1px solid',
              borderColor: 'divider',
              '&:last-child': { borderBottom: 'none' },
              '&:hover': { backgroundColor: 'action.hover' },
            }}
          >
            <Box />
            <Box
              sx={{
                pl: 4,
                position: 'sticky',
                left: 40,
                backgroundColor: 'inherit',
                zIndex: 1,
                fontWeight: 500,
                fontSize: '13px',
              }}
            >
              {invoice.name}
            </Box>
            {monthHeaders.map((monthHeader) => (
              <Box key={monthHeader} sx={cellSx}>
                {breakdownInvoice.monthKey === monthHeader ? (
                  <Price currency={currency} fractionDigits={2}>
                    {invoice.total}
                  </Price>
                ) : (
                  <Typography variant="body2" sx={{
                    color: "text.disabled"
                  }}>
                    -
                  </Typography>
                )}
              </Box>
            ))}
            <Box sx={cellSx}>
              <Price currency={currency} fractionDigits={2}>
                {invoice.total}
              </Price>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
